import React from 'react';
import SummaryItem from '../SummaryItem';

// Utils
import { getDateDifference } from '../../../../../../utils/dates/date.utils';

const FullTimeStudentInfo = props => {

    const {
        applyingForCoverageIndicator,
        dateOfBirth,
        idx,
        fullTimeStudent,
        serverDate
    } = props;

    const isFullTimeStudent = () => {
        const age = getDateDifference(serverDate, dateOfBirth, 'year');
        return age >= 18 && age <= 22 && applyingForCoverageIndicator;
    };

    if(!isFullTimeStudent()) {
        return null;
    }

    return (
        <SummaryItem
            textCode = 'common.full_time_student'
            value = { fullTimeStudent }
            desc = {
                [
                    [
                        `taxHousehold.householdMember[${ idx }].fullTimeStudent`
                    ]
                ]
            }
        />
    );
};

export default FullTimeStudentInfo;